import * as unirest from 'unirest'
// const autozone_serverUrl = 'http://localhost:8080';
const autozone_serverUrl = 'https://autozone-tms.ew.r.appspot.com';

export function authorise(idToken, oauth2 = false, ouathPayload = null){
//   console.log('auth request going out...');
  return unirest
  .post(autozone_serverUrl + '/request_authorisation_autozone')  //first use case... will change in template for other use cases
  .headers({
      'Accept': 'application/json',
      'Content-Type': 'application/json',
      'Cache-Control' : 'max-age=0'
  })
  .send({token:idToken, oauth2: oauth2, oauthpayload: ouathPayload})
  .then(reply => {
      if (reply.body){
          // console.log('reply :>> ', reply);
          reply.body.statusCode = reply.statusCode;
          reply.body.statusMessage = reply.statusMessage;
          return reply.body;
      } else {
          return reply;
      }
  });
          
}

export function localServer(){
    // console.log('called auth');
    return autozone_serverUrl.includes('localhost');
}